import { styled } from "@mui/material/styles";

export const HeaderContainer = styled("div")(() => ({
  flexGrow: 2,
  marginRight: "0.313rem",
  marginLeft: "1rem",
  width: "0.5rem",
}));
